<script lang="ts" setup></script>

<template>
  <i18n-t tag="p" keypath="loginSignup.loginOrSignUpIntroText">
    <strong>{{ $t("loginSignup.loginActionText") }}</strong>
    <strong>{{ $t("loginSignup.createAProfile") }}</strong>
  </i18n-t>
</template>
